import { render, staticRenderFns } from "./BaseTimePickerHijri.vue?vue&type=template&id=5e4f4a82&scoped=true&"
import script from "./BaseTimePickerHijri.vue?vue&type=script&lang=js&"
export * from "./BaseTimePickerHijri.vue?vue&type=script&lang=js&"
import style0 from "./BaseTimePickerHijri.vue?vue&type=style&index=0&id=5e4f4a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f4a82",
  null
  
)

export default component.exports